var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.478,
    height: 26.609,
    viewBox: "0 0 22.478 26.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-hourglass",
    "data-name": "Icon ionic-ios-hourglass",
    d: "M27.311,28.317h-.329c-.42,0-.775-.058-.82-.478v-.006c-.943-8.777-6.472-8.945-6.472-11.012s5.535-2.235,6.472-11.012V5.8c.045-.42.4-.478.82-.478h.329a.926.926,0,0,0,.93-.859.905.905,0,0,0-.9-.949H6.7a.926.926,0,0,0-.93.859.905.905,0,0,0,.9.949h.355c.42,0,.775.058.82.478v.006c.943,8.777,6.472,8.945,6.472,11.012S8.782,19.055,7.845,27.832v.006c-.045.42-.4.478-.82.478H6.7a.926.926,0,0,0-.93.859.905.905,0,0,0,.9.949H27.337a.9.9,0,0,0,.9-.949A.926.926,0,0,0,27.311,28.317Zm-16.3-2.209c1.854-5.154,5.141-4.527,5.141-6.562V15.955c0-1.253-2.377-2.125-3.862-4.159a.505.505,0,0,1,.42-.8H21.3a.5.5,0,0,1,.433.788c-1.46,2.041-3.882,2.919-3.882,4.172v3.591c0,2.015,3.158,1.466,5.154,6.562.181.459.045,1.033-.446,1.033h-11.1C10.965,27.141,10.848,26.573,11.016,26.108Z",
    transform: "translate(-5.764 -3.516)",
    fill: "#7c7c7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon-sort.19c2806d.svg";
export { ForwardRef as ReactComponent };